import React from 'react';

export interface BadgeProps {
  children: React.ReactNode;
  variant?: 'default' | 'primary' | 'secondary' | 'success' | 'warning' | 'error';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const Badge = React.forwardRef<HTMLSpanElement, BadgeProps>(
  ({ children, variant = 'default', size = 'md', className = '', ...props }, ref) => {
    const baseClasses = 'inline-flex items-center font-medium rounded-full';

    const sizeClasses = {
      sm: 'px-2 py-1 text-xs',
      md: 'px-2.5 py-1.5 text-sm',
      lg: 'px-3 py-2 text-base',
    };

    const variantClasses = {
      default: 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-200',
      primary: 'bg-xtnd-blue-100 text-xtnd-blue-900 dark:bg-xtnd-blue-900 dark:text-xtnd-blue-100',
      secondary: 'bg-xtnd-dark-100 text-xtnd-dark-800 dark:bg-xtnd-dark-600 dark:text-white',
      success: 'bg-green-100 text-green-900 dark:bg-green-900 dark:text-green-200',
      warning: 'bg-yellow-100 text-yellow-900 dark:bg-yellow-900 dark:text-yellow-200',
      error: 'bg-red-100 text-red-900 dark:bg-red-900 dark:text-red-200',
    };

    return (
      <span
        ref={ref}
        className={`
          ${baseClasses}
          ${sizeClasses[size]}
          ${variantClasses[variant]}
          ${className}
        `.trim()}
        {...props}
      >
        {children}
      </span>
    );
  }
);

Badge.displayName = 'Badge';

export default Badge;
